import React from "react";
import { Helmet } from "react-helmet-async";

export default function WeblaxStudio() {
  const titlePage = 'Weblax Studio | Weblax';
  const description = 'Site de l’agence Weblax présentant ses services digitaux et son expertise web.';

  return (
    <>
      <Helmet>
        <title>{titlePage}</title>
        <meta name="description" content={description} />
      </Helmet>

      <main className="weblax-container py-20">
        <h1 className="weblax-heading-display mb-6">Weblax Studio</h1>
        <p className="text-lg text-muted-foreground mb-10">Site de l’agence Weblax présentant ses services digitaux et son expertise web.</p>


        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Contexte</h2>
          <p className="text-muted-foreground">Créer une identité forte.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Solution</h2>
          <p className="text-muted-foreground">Site corporate optimisé SEO.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Résultats</h2>
          <p className="text-muted-foreground">Meilleure conversion leads.</p>
        </section>
        
      </main>
    </>
  );
}
